<template>
  <div class="complete">
    <div class="complete__info">
      <div class="complete__content">
        <div class="complete__icon-wrapper">
          <CheckOrderCompleteIcon class="complete__icon" />
        </div>
        <h4 class="complete__title">Your order is complete!</h4>
        <div class="complete__text-wrapper">
          <p class="complete__text">
            Congratulations on taking your technical training to the next level! We’re thrilled to
            be a part of your journey!
          </p>
          <p class="complete__text">
            {{ congratsTextPart }}
          </p>
        </div>
        <button @click="handleRedirect" class="btn btn--primary complete__button">
          Start Training
        </button>
      </div>
      <div class="complete__social-wrapper">
        <SocialShareWidget />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CheckOrderCompleteIcon from '@/assets/icons/check_order_complete.svg'
import SocialShareWidget from '@/components/flow/SocialShareWidget.vue'
import CONSTANTS from '@/constants'

const { PLANS, PREMIUM_PLANS } = CONSTANTS

export default {
  name: 'Complete',
  components: {
    CheckOrderCompleteIcon: { ...CheckOrderCompleteIcon, name: 'CheckOrderCompleteIcon' },
    SocialShareWidget,
  },
  computed: {
    ...mapGetters({
      shoppingCart: 'shoppingCart/getShoppingCart',
    }),
    streamingLink() {
      return `${process.env.VUE_APP_STREAMING_URL}`
    },
    cartHasPremiumSubscription() {
      return this.shoppingCart.some(item => item.merchant_id === PLANS.PREMIUM)
    },
    cartHasFundamentasSubscription() {
      return this.shoppingCart.some(item => item.merchant_id === PLANS.ANNUAL)
    },
    congratsTextPart() {
      if (this.cartHasPremiumSubscription) {
        return 'Your 50% off exam redemption code will be sent to your email shortly. If you have not received the email one hour after purchase, please check your spam folder or contact support for assistance.'
      }
      if (this.cartHasFundamentasSubscription) {
        return 'Your voucher redemption codes for the eJPT and ICCA exams will be sent to your email shortly. If you have not received the email one hour after purchase, please check your spam folder or contact support for assistance.'
      }
      return 'You will receive a confirmation email with order details shortly.'
    },
  },
  methods: {
    handleRedirect() {
      const { streamingLink } = this
      window.location.assign(`https://${streamingLink}`)
    },
  },
}
</script>

<style lang="scss">
.complete {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  padding-bottom: 130px;
  @include mobile {
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
  }
  @include desktop {
    padding-top: 90px;
    padding-bottom: 90px;
    height: 100%;
  }
  &__info {
    display: flex;
    height: 100%;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    color: var(--white);
    font-family: var(--font-regular);
    padding: 20px;
    @include mobile {
      padding: 0 50px;
    }
    @include tablet {
      padding: 0;
      width: 50%;
      height: 569px;
    }
  }
  &__content {
    text-align: center;
  }
  &__title {
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    font-family: var(--font-regular);
    padding: 0;
    margin: 0;
  }
  &__icon-wrapper {
    height: 200px;
    margin-bottom: 50px;
  }
  &__text-wrapper {
    padding: 20px;
    @include tablet {
      padding: 0 30px 0 30px;
    }
  }
  &__text {
    color: var(--dusty-gray);
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    &--alert {
      color: var(--white);
    }
    &--link {
      color: var(--white);
      &:hover {
        color: var(--orange);
      }
    }
  }
  &__social {
    &__title {
      width: 80%;
    }
    &-wrapper {
      @include mobile {
        margin-top: 100px;
      }
      @include tablet {
        height: 157px;
        margin: auto 0 0 0;
        margin-bottom: 10%;
      }
    }
  }
  &__button {
    width: 80%;
    height: 36px;
    font-size: 12px;
    @include mobile {
      width: unset;
      height: 48px;
      font-size: 1rem;
    }
  }
}
</style>
